import {axiosReqGet, axiosReqOther} from "./config";
import { store } from '../store/store';

const USER_TOKEN = store.getState().authentication.user;

export const Ads = {
    postAd,
    validatePropertyTitle
}

function postAd(post){
    const url = 'property/create-ads.json';
    return axiosReqOther(url, post, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        return err; 
    });
}

function validatePropertyTitle(post){
    const url = 'property/validate-property-title.json';
    return axiosReqOther(url, post, 'post').then(res => {              
        return res;       
    })
    .catch(err => { 
        return err; 
    });
}

export default Location;